module.exports = __webpack_public_path__ + "img/dinners-club@2x.d4b6633b.png";